export var GanularytyOptions;
(function (GanularytyOptions) {
    GanularytyOptions["DAY"] = "day";
    GanularytyOptions["WEEK"] = "week";
    GanularytyOptions["MONTH"] = "month";
})(GanularytyOptions || (GanularytyOptions = {}));
export var CompanyDataAnalysisViewType;
(function (CompanyDataAnalysisViewType) {
    CompanyDataAnalysisViewType["Table"] = "table";
    CompanyDataAnalysisViewType["Chart"] = "chart";
})(CompanyDataAnalysisViewType || (CompanyDataAnalysisViewType = {}));
